import React from 'react';
import { Helmet } from 'react-helmet';

const Pageheader = props => {
    // Consistent metadata for all pages
    const title = 'Lens: The Merger OS (TM)';
    const description =
        'Lens is an enterprise solution by Beyond M&A to manage and streamline Due Diligence, M&As, and Post-Merger Integration. Identify business gaps, remediate weaknesses, maximise value.';

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta
                name="keywords"
                content="due diligence, M&A, investment readiness, technology assessment, virtual data room, enterprise software, business analysis, risk assessment, post-merger integration"
            />
            <meta name="author" content="Beyond M&A" />
            <meta name="robots" content="index, follow" />
            <meta name="language" content="en" />
            <meta name="revisit-after" content="7 days" />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://lens-dd.ai/" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content="%PUBLIC_URL%/logo512.png" />
            <meta property="og:site_name" content="LENS" />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content="https://lens-dd.ai/" />
            <meta property="twitter:title" content={title} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content="%PUBLIC_URL%/logo512.png" />

            {/* Additional SEO */}
            <meta name="theme-color" content="#003048" />
            <meta name="msapplication-TileColor" content="#003048" />
            <meta name="msapplication-TileImage" content="%PUBLIC_URL%/logo192.png" />

            <meta charset="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
        </Helmet>
    );
};

export default Pageheader;
